@if (showLanguageName) {
  <button
    type="button"
    [matMenuTriggerFor]="flags"
    class="language-trigger login-language-trigger"
    [attr.aria-label]="'language' | translate">
    <img [src]="selectedLanguage.icon" class="language-flag rounded-circle object-cover" alt="" />
    <span class="language-name">{{ selectedLanguage.language }}</span>
    <span class="language-chevron" aria-hidden="true"></span>
  </button>
} @else {
  <button
    type="button"
    [matMenuTriggerFor]="flags"
    mat-icon-button class="language-trigger m-r-5"
    [attr.aria-label]="'language' | translate">
      <img [src]="selectedLanguage.icon" class="language-flag rounded-circle object-cover" alt="" />
  </button>
}
<mat-menu
  #flags="matMenu"
  [class]="menuPanelClass">
  @for(lang of languages; track lang.code) {
    <button mat-menu-item (click)="changeLanguage(lang)">
      <div class="d-flex align-items-center">
        <img [src]="lang.icon" class="rounded-circle object-cover m-r-8 icon-20" />
        <span class="mat-subtitle-1 f-s-14">{{ lang.language }}</span>
      </div>
    </button>
  }
</mat-menu>
